/**
 * 会場限定販売 フロントエンド JavaScript (GPSのみ版)
 *
 * 使い方:
 * 1. このファイルをテーマの assets フォルダにアップロード
 * 2. product.liquid で読み込み:
 *    <script src="{{ 'venue-check.js' | asset_url }}" defer></script>
 * 3. 商品ページで VenueCheck.init() を呼び出す
 *
 * バリアントのメタフィールドに会場座標を設定:
 *   namespace: "variant"
 *   key: "venue_config"
 *   value: {"lat": 35.6812, "lng": 139.7671, "radius": 100, "name": "会場名"}
 */

(function () {
  'use strict';

  /**
   * 2点間の距離を計算（メートル単位）- Haversine公式
   */
  function calculateDistance(lat1, lng1, lat2, lng2) {
    const EARTH_RADIUS_METERS = 6371e3;

    const lat1Rad = (lat1 * Math.PI) / 180;
    const lat2Rad = (lat2 * Math.PI) / 180;
    const latDiffRad = ((lat2 - lat1) * Math.PI) / 180;
    const lngDiffRad = ((lng2 - lng1) * Math.PI) / 180;

    const a =
      Math.sin(latDiffRad / 2) * Math.sin(latDiffRad / 2) +
      Math.cos(lat1Rad) * Math.cos(lat2Rad) *
      Math.sin(lngDiffRad / 2) * Math.sin(lngDiffRad / 2);

    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

    return EARTH_RADIUS_METERS * c;
  }

  const VenueCheck = {
    config: {
      gpsTimeout: 10000,
      buttonSelector: '[data-add-to-cart]',
    },

    /**
     * 初期化
     */
    init(options = {}) {
      this.config = { ...this.config, ...options };
      this.checkProduct();
    },

    /**
     * 商品が会場限定かチェック
     */
    checkProduct() {
      const variant = this.getCurrentVariant();
      if (!variant) {
        return;
      }

      const venueConfig = this.getVenueConfig(variant);
      if (!venueConfig) {
        this.enableCartButton();
        return;
      }

      this.disableCartButton('位置情報を確認中...');
      this.verifyLocation(venueConfig);
    },

    /**
     * 現在のバリアントを取得
     */
    getCurrentVariant() {
      const productData = this.getProductData();
      if (!productData) {
        return null;
      }

      const currentVariantId = this.getCurrentVariantId();
      return productData.variants.find(v => String(v.id) === String(currentVariantId));
    },

    /**
     * 商品データを取得
     */
    getProductData() {
      const productJson = document.querySelector('[data-product-json]');
      if (productJson) {
        try {
          return JSON.parse(productJson.textContent);
        } catch (e) {
          return null;
        }
      }

      if (window.product) {
        return window.product;
      }

      return null;
    },

    /**
     * 現在選択中のバリアントIDを取得
     */
    getCurrentVariantId() {
      const select = document.querySelector('select[name="id"]');
      if (select) {
        return select.value;
      }

      const input = document.querySelector('input[name="id"]');
      if (input) {
        return input.value;
      }

      return null;
    },

    /**
     * バリアントから会場設定を取得
     * メタフィールド: namespace="variant", key="venue_config"
     */
    getVenueConfig(variant) {
      if (!variant.metafields?.variant?.venue_config) {
        return null;
      }

      try {
        const rawConfig = variant.metafields.variant.venue_config;
        const config = typeof rawConfig === 'string'
          ? JSON.parse(rawConfig)
          : rawConfig;

        if (typeof config.lat !== 'number' || typeof config.lng !== 'number') {
          return null;
        }

        return {
          lat: config.lat,
          lng: config.lng,
          radius: config.radius || 100,
          name: config.name || '会場',
        };
      } catch (e) {
        return null;
      }
    },

    /**
     * GPS位置情報で会場内かどうかを検証
     */
    verifyLocation(venueConfig) {
      if (!navigator.geolocation) {
        this.disableCartButton('会場限定商品です');
        return;
      }

      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { latitude, longitude } = position.coords;
          const distance = calculateDistance(latitude, longitude, venueConfig.lat, venueConfig.lng);

          if (distance <= venueConfig.radius) {
            this.enableCartButton();
          } else {
            this.disableCartButton('会場限定商品です');
          }
        },
        () => {
          this.disableCartButton('会場限定商品です');
        },
        {
          enableHighAccuracy: true,
          timeout: this.config.gpsTimeout,
          maximumAge: 0,
        }
      );
    },

    /**
     * カートボタンを有効化
     */
    enableCartButton() {
      const button = document.querySelector(this.config.buttonSelector);
      if (button) {
        button.disabled = false;
        if (button.dataset.originalText) {
          button.textContent = button.dataset.originalText;
        }
      }
    },

    /**
     * カートボタンを無効化
     */
    disableCartButton(message) {
      const button = document.querySelector(this.config.buttonSelector);
      if (button) {
        if (!button.dataset.originalText) {
          button.dataset.originalText = button.textContent;
        }
        button.disabled = true;
        button.textContent = message;
      }
    },
  };

  window.VenueCheck = VenueCheck;
})();
